// extracted by mini-css-extract-plugin
export default {"container":"ProjectCategoryCard_container__FTiLG","content":"ProjectCategoryCard_content__wkiiP","title":"ProjectCategoryCard_title__MkME3"};